import styled from 'styled-components';

export const WrapperComparativo = styled.div`
  grid-area: 2 / 1 / 3 / 3;
  display: flex;
  flex-direction: column;
  .table-information {
    display: flex;
    width: 30vw;
    margin: 20px;
  }
  .chart-table {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }
`;

export const TableComparativo = styled.div`
  display: flex;
`;

export const WrapperInput = styled.div`
  width: 30%;
  padding: 10px;
  .subtitle-input {
    font-size: 14px;
    font-weight: bold;
    margin-left: 5px;
  }
`;

export const WrapperInputsGraficas = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: ${(props) => (props.enableMarginBottom ? '-2rem' : 0)};
`;
